import { useQuery } from '@tanstack/react-query'
import { mailSettingsApi } from './service'
import { mailSettingsKeys } from './keys'

export function useMailSettings() {
  return useQuery({
    queryKey: mailSettingsKeys.detail(),
    queryFn: () => mailSettingsApi.get().then((r) => r.data),
  })
}
